import React, { Component } from "react";
import { imageAddress, translate } from "../../utils/useful";
import FixedView from "../../components/FixedView";
import LoaderButton from "../../components/LoaderButton";
import HttpServices from "../../utils/Http.services";

class SearchUsersFixedView extends Component {
    state = {
        data: [],
        user: {},
    }

    componentDidMount() {
        this.initData()
    }

    componentDidUpdate(prevProps) {
        if (prevProps.hubsInitData != this.props.hubsInitData) {
            this.initData()
        }
    }

    initData = () => {
        this.fetchData()
        let user = this.state.user
        user = {}
        this.setState({ user }, () => {
            setTimeout(() => {

                console.log('userrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrr3', this.props.hubsInitData)
                console.log('userrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrr4', this.state.user)
                if (Array.isArray(this.props.hubsInitData)) {
                    console.log('userrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrr2', this.props.hubsInitData)
                    let user = this.state.user
                    this.props.hubsInitData.forEach(element => {
                        console.log('userrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrr1', element)
                        user[element._id] = element//{ _id: element._id, removed: false, init: true }
                        user[element._id].removed = false
                        user[element._id].init = true
                    });
                }
            }, 1000);
        })
    }

    fetchData = () => {
        this.setState({ isLoadingData: true })
        HttpServices.request('searchUser', { appletHub: this.props.variables?.appletHub }, (fetchResult, fetchError, fetchStatus) => {
            this.setState({ isLoadingData: false })
            if (fetchError) {
                return
            }
            this.setState({ rawData: fetchResult.info, data: fetchResult.info })
        })
    }

    onDone = (prop) => {
        let user = this.state.user
        console.log('userrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrr', prop)
        // user = { _id: prop._id, fullname: prop.fullname, image: prop.image, type: prop.type, username: prop.username }

        if (!user[prop._id] || user[prop._id].removed) {
            user[prop._id] = { _id: prop?._id, fullname: prop?.fullname, image: prop?.image, type: prop?.type, username: prop?.username }
        } else {
            if (user?.owner && this.props.mainAccess) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.canNotChange', description: "The owner can not be removed from the main access list" })

                //= { id: prop._id, fullname:prop.fullname,type:prop.type,username:prop.username,uType:'user',removed: true, init: false }
            } else {
                console.log('user[prop._id]', user)
            }
        }

        let final
        final = user[prop._id]
        console.log('user[prop._id]1', final)
        this.setState({ user }, () => {
            setTimeout(() => {
                this.props.onDone('users', final, 'hub', () => {
                })
            }, 50);
        })
    }

    render() {
        return (
            <div className='bg-white br-10 p-1 shadow-3 sc-gray2' style={{}}>
                <div className="d-flex h-100 flex-column w-100 scroll-no-scrollbar" style={{ backgroundColor: '#fff', borderRadius: 8, position: 'relative', }}>
                    <div className="w-100 text-start " >
                        {this.state.data.map((prop, index) => {
                            return (
                                <div key={index} onClick={() => this.onDone(prop)} className="flexcb backHover pld-3 prd-4 pb-2 pt-2 cursor-pointer transition-all" style={{}}>
                                    <div className='flexcc mrd-3'>
                                        <div>
                                            <img src={imageAddress(prop.image, 'profile', 'thumb')} width="36px" style={{ borderRadius: 50, height: 36, objectFit: 'cover' }} />
                                        </div>
                                        <div className="px-2">
                                            <p className="text-small text-semibold  ">{prop.fullname}</p>
                                            {prop.username ? (
                                                <p className="text-smaller " style={{ color: '#789' }}>{prop.username}</p>
                                            ) : (
                                                <p className="text-smaller " style={{ color: '#789' }}>{translate('ca.Virtual User')}</p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                        {this.state.data?.length === 0 && (
                            <div className="text-center my-3">
                                {/* <img src="/images/target.svg" width="50px" /> */}
                                <p className="text-center text-small">{translate('found-nothing')}</p>
                                {/* <p className="text-center text-smaller">{translate('ca.Change your search options')}</p> */}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}


export default SearchUsersFixedView;